
const RSIRegistration = ({
    pageTitle,
    Header,
    Back,
    currentPage,
    handleBackClick,
    subPageTitle,
    PatientRegistrationFormData,
    handleInputChange,
    isNext,
    invalidFields,
    handleZipSearch,
    languageOptions,
    genderOptions,
    FormHeader,
    FormInput,
    TextInput,
    pageRefs,
    setPatientRegistrationFormData,
    SelectInput,
    ImageConsent,
    Paragraph,
    signatures,
    canvasRefs,
    isEditing,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    MedicalPortalAccess,
    isDisabled,
    ethnicityOptions,
    raceOptions,
    maritalOptions,
    emergencyRelationshipOptions,
    formattedDate,
    age,
    showPatientSignature,
    setShowPatientSignature,
    showPatientSignaturePage4,
    showPatientSignaturePage5,
    showPatientSignaturePage6,
    setShowPatientSignaturePage4,
    setShowPatientSignaturePage5,
    setShowPatientSignaturePage6,
    AssignmentRelease,
    Signature,
    DisabledTextBox,
    nextLoader,
    ButtonGroup,
    handleAddMember,
    handleFamilyContentChange,
    handleRemoveFamilyMember,
    handleFamilyHistoryChange,
    handleEdit,
    handleNext,
    handlePatientRegistration,
    handleCheckboxChange,
    handleCheckChange,
    FaPlus,
    FaTrash,
    PrivacyConsent,
    FinancialPolicy,
    DynamicCheckbox,
    FamilyDiseases,
    DOBPickerInput,
    FamilyMemberConsent,
    SymptomCheckboxGroup,
    isLast,
    Agree,
    PCMConsent,
    Insurance,
    onFormStateChange
}) => {
    return (
        <>
            <Header pageTitle={pageTitle} />
            <form className="force-light-mode">
                {currentPage > 0 && (
                    <Back onClick={handleBackClick} />
                )}
                {/* Page 1 */}
                {currentPage === 0 && (
                    <div ref={pageRefs.current[currentPage]}
                        className={`
                                bg-white w-full mx-auto
                                ${!isNext
                                ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                                : "w-full md:max-w-[1200px] md:mx-auto"
                            }
                        `}

                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: true,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: true,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            {/* Address */}
                            <TextInput
                                id="address"
                                label="Address"
                                required
                                value={PatientRegistrationFormData.address}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                            />

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "city",
                                        label: "City",
                                        required: true,
                                    },
                                    {
                                        id: "state",
                                        label: "State",
                                        required: true,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                                {!isNext && (
                                    <p className="text-sm text-muted-foreground mt-2">
                                        City and State can be filled by using Zip
                                    </p>
                                )}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key="zip"
                                    id="zip"
                                    label="Zip"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["zip"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Zip") && !PatientRegistrationFormData["zip"]}
                                    required={true}
                                    onZipSearch={handleZipSearch}
                                />

                                <FormInput
                                    key="homephone"
                                    id="homephone"
                                    label="Home Phone"
                                    type="number"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["homephone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Home Phone") && !PatientRegistrationFormData["homephone"]}
                                    required={false}
                                />

                            </div>

                            <Paragraph>We may use your phone number for appointment reminders and care-related communication.</Paragraph>


                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "cellphone",
                                        label: "Cell Phone",
                                        required: true,
                                    },
                                    {
                                        id: "ssn",
                                        label: "SSN",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="number"
                                        disabled={isNext}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label)}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <DOBPickerInput
                                    id="dob"
                                    label="DOB"
                                    value={PatientRegistrationFormData.dob}
                                    onChange={(date) => {
                                        const formattedDate = date
                                            ? `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
                                                .getDate()
                                                .toString()
                                                .padStart(2, "0")}/${date.getFullYear()}`
                                            : "";
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            dob: formattedDate,
                                        }));
                                    }}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("Date of Birth")}
                                    required={true}
                                />

                                {/* Preferred Language */}
                                <SelectInput
                                    id="preferredLanguage"
                                    label="Preferred Language"
                                    options={languageOptions}
                                    value={PatientRegistrationFormData.language}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            language: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                                    errorMessage="Please select a language."
                                />
                            </div>

                            {/* Gender Radio Buttons */}
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <SelectInput
                                    id="gender"
                                    label="Gender"
                                    options={genderOptions}
                                    value={PatientRegistrationFormData.gender}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            gender: e.target.value,
                                        }))
                                    }
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                                    errorMessage="Please select a gender."
                                    required={true}
                                />

                            </div>
                            <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">


                                {/* reminderPhone */}
                                <DynamicCheckbox
                                    label="Yes, I agree to receive occasional text messages from Retina Specialty Institute about updates, services, and events. Message and data rates may apply. Message frequency varies. I understand that I can opt-out at any time."
                                    fieldName="consentToText"
                                    id="consentToText"
                                    isChecked={PatientRegistrationFormData.consentToText}
                                    onChange={handleCheckChange}
                                    isDisabled={nextLoader}
                                    showError={invalidFields.includes("consentToText")}
                                />
                            </div>
                            <Paragraph>We use your email to send important information related to your care, including appointment confirmations, forms, and follow-up instructions.</Paragraph>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* email*/}

                                <FormInput
                                    key='email'
                                    id='email'
                                    label='Email'
                                    type="text"
                                    disabled={isNext || PatientRegistrationFormData.no_email}
                                    value={PatientRegistrationFormData.no_email === true ? "" : PatientRegistrationFormData['email']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('Email')}
                                    required={false}
                                />
                                <DynamicCheckbox
                                    label="No Email"
                                    fieldName="no_email"
                                    id="no_email"
                                    isChecked={PatientRegistrationFormData.no_email}
                                    onChange={handleCheckChange}
                                    isDisabled={isNext}
                                    showError={invalidFields.includes("no_email")}
                                />

                            </div>

                            {
                                Boolean(PatientRegistrationFormData?.email?.trim()) && (
                                    <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">
                                        <DynamicCheckbox
                                            label="Yes, I would like to receive occasional updates from Retina Specialty Institute, including helpful eye care information, new services, and practice updates. I understand I can unsubscribe at any time."
                                            fieldName="emailConsent"
                                            id="emailConsent"
                                            isChecked={PatientRegistrationFormData.emailConsent}
                                            onChange={handleCheckChange}
                                            isDisabled={nextLoader}
                                            showError={invalidFields.includes("emailConsent")}
                                        />
                                    </div>
                                )
                            }

                            {/* Portal */}
                            <MedicalPortalAccess
                                id="portal"
                                label="Would you like to have access to your Medical Records / Portal?"
                                portalValue={PatientRegistrationFormData.portal}
                                onChange={handleInputChange}
                                isDisabled={isNext}
                            />

                            {/* ethnicity Radio Buttons */}

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <SelectInput
                                    id="ethnicity"
                                    label="Ethnicity"
                                    options={ethnicityOptions}
                                    value={PatientRegistrationFormData.ethnicity}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            ethnicity: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("ethnicity")}
                                />

                                <SelectInput
                                    id="race"
                                    label="Race"
                                    options={raceOptions}
                                    value={PatientRegistrationFormData.race}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            race: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("race")}
                                    errorMessage="Please select a race."
                                />
                            </div>

                            {/* Marital Status Radio Buttons */}
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>


                                <SelectInput
                                    id="maritalStatus"
                                    label="Marital Status"
                                    options={maritalOptions}
                                    value={PatientRegistrationFormData.maritalStatus}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            maritalStatus: e.target.value,
                                        }))
                                    }
                                    disabled={isDisabled}
                                    invalid={invalidFields.includes("maritalStatus")}
                                    errorMessage="Please select a marital status."
                                />

                            </div>
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* referred by */}

                                <FormInput
                                    key="referredBy"
                                    id="referredBy"
                                    label="Referred By"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["referredBy"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Referred By")}
                                    required={true}
                                />

                                {/* family doctor */}
                                <FormInput
                                    key="familyDoctor"
                                    id="familyDoctor"
                                    label="Family Doctor"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["familyDoctor"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Family Doctor")}
                                    required={true}
                                />

                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* parentspouse*/}

                                <FormInput
                                    key="parentspouse"
                                    id="parentspouse"
                                    label="Parent-Spouse"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["parentspouse"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("parentspouse")}
                                    required={false}
                                />

                                {/* state*/}
                                <FormInput
                                    key="state"
                                    id="state"
                                    label="State"
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData["state"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("State")}
                                    required={false}
                                />

                            </div>
                        </div>
                    </div>
                )}
                {/* Page 2 */}
                {currentPage === 1 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>


                            <div className="mb-4 grid grid-cols-1 gap-4">
                                <div className="flex items-center">
                                    <Paragraph> {PatientRegistrationFormData.firstName}{" "}
                                        {PatientRegistrationFormData.lastName} - {formattedDate} </Paragraph>
                                </div>
                            </div>
                            <div className="mb-2">
                                <label className="block text-base font-medium text-black w-full md:w-1/4">
                                    If Patient Is a Minor, Authorized By:
                                </label>

                                <div className="w-full rounded-lg bg-white mt-4">
                                    {/* Signature Label */}


                                    {/* Signature Canvas */}
                                    <div className="relative">
                                        {PatientRegistrationFormData.isMinor ? (

                                            <Agree
                                                showAgreement={showPatientSignaturePage6}
                                                setShowAgreement={setShowPatientSignaturePage6}
                                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                                formData={PatientRegistrationFormData}
                                                title={"Patient/Responsible Party Signature"}
                                            />
                                        ) : (
                                            <DisabledTextBox></DisabledTextBox>

                                        )}
                                    </div>
                                </div>
                            </div>
                            {!isNext && PatientRegistrationFormData.isMinor && !PatientRegistrationFormData.responsiblePersonSignature && (
                                <div className="my-2">
                                    <p className="text-sm text-black-600">
                                        Click on the save button to save the signature
                                    </p>
                                </div>
                            )}

                            <DynamicCheckbox
                                label="Retired"
                                fieldName="retired"
                                id="retired"
                                isChecked={PatientRegistrationFormData.retired}
                                onChange={handleCheckChange}
                                isDisabled={isNext}
                                showError={invalidFields.includes("retired")}
                            />

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "employee",
                                        label: "Employer",
                                        required: false,
                                    },
                                    {
                                        id: "employeeEmail",
                                        label: "Employee Email",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={PatientRegistrationFormData.retired || isNext}
                                        value={PatientRegistrationFormData.retired === true ? "" : PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label)}
                                        required={required}
                                    />
                                ))}
                            </div>



                            <div>
                                <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                    {/* work phone */}

                                    <FormInput
                                        key='workphone'
                                        id='workphone'
                                        label='Work Phone'
                                        type="number"
                                        disabled={PatientRegistrationFormData.retired || isNext}
                                        value={PatientRegistrationFormData.retired === true ? "" : PatientRegistrationFormData['workphone']}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes('Work Phone') && !PatientRegistrationFormData['workphone']}
                                        required={false}
                                    />


                                    <FormInput
                                        key='employeeExtn'
                                        id='employeeExtn'
                                        label='Extension'
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData['employeeExtn']}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes('Extension') && !PatientRegistrationFormData['employeeExtn']}
                                        required={false}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-base font-medium text-black w-full md:w-1/4">
                                    In Case Of Emergency Notify
                                </label>
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key="emergencyName"
                                    id="emergencyName"
                                    label="Name"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["emergencyName"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Emergency Name") && !PatientRegistrationFormData["emergencyName"]}
                                    required={false}
                                />

                                <SelectInput
                                    id="emergencyRelationship"
                                    label="Relationship"
                                    options={emergencyRelationshipOptions}
                                    value={PatientRegistrationFormData.emergencyRelationship}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            emergencyRelationship: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("Emergency Relationship")}
                                    errorMessage="Please select a emergency relationship."
                                />
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="emergencyPhone"
                                    id="emergencyPhone"
                                    label='Phone'
                                    type="number"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["emergencyPhone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('Emergency Phone') && !PatientRegistrationFormData["emergencyPhone"]}
                                    required={false}
                                />
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <MedicalPortalAccess
                                    id="hospitalized"
                                    label="Have you been hospitalized in the past six months?"
                                    portalValue={PatientRegistrationFormData.hospitalized}
                                    onChange={handleInputChange}
                                    isDisabled={isNext}
                                />
                                <div>
                                    <Paragraph>If yes, are you currently in a rehab or skilled nursing facility?</Paragraph>
                                    <FormInput
                                        key="nursing_facility"
                                        id="nursing_facility"
                                        label="Facility Name"
                                        type="text"
                                        disabled={isNext || PatientRegistrationFormData.hospitalized !== "true"}
                                        value={PatientRegistrationFormData["nursing_facility"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Nursing Facility") && !PatientRegistrationFormData["nursing_facility"]}
                                        required={false}
                                    />
                                </div>
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <MedicalPortalAccess
                                    id="residing_facility"
                                    label="Are you presently residing in a skilled nursing or rehabilitation facility?"
                                    portalValue={PatientRegistrationFormData.residing_facility}
                                    onChange={handleInputChange}
                                    isDisabled={isNext}
                                />
                                <div>
                                    <Paragraph>Are you presently residing in a skilled nursing or
                                        rehabilitation facility?</Paragraph>

                                    <FormInput
                                        key="facility_name"
                                        id="facility_name"
                                        label="Facility Name"
                                        type="text"
                                        disabled={isNext || PatientRegistrationFormData.residing_facility !== "true"}
                                        value={PatientRegistrationFormData["facility_name"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Facility Name") && !PatientRegistrationFormData["facility_name"]}
                                        required={false}
                                    />
                                </div>

                            </div>

                              <Insurance
                                insuranceData={PatientRegistrationFormData.insurance_data}
                                onInsurancesChange={(updatedInsurances) => {
                                    setPatientRegistrationFormData(prev => ({
                                        ...prev,
                                        insurance_data: updatedInsurances
                                    }));
                                }}
                                onFormStateChange={onFormStateChange}
                                key="insurance-component"
                                isNext = {isNext}
                            />

                        </div>
                    </div>
                )}
                {/* Page 3 */}
                {currentPage === 2 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <AssignmentRelease />
                            <div className="mb-6">
                                <Paragraph>
                                    {PatientRegistrationFormData.firstName}{" "}
                                    {PatientRegistrationFormData.lastName} - {formattedDate}
                                </Paragraph>
                            </div>


                            <div className="w-full rounded-lg bg-white">
                                {/* Signature Label */}
                                <div className="w-full sm:w-1/2 rounded-lg bg-white">

                                    {/* Signature Canvas */}
                                    <div className="relative">
                                        {!PatientRegistrationFormData.isMinor ? (

                                            <Agree
                                                showAgreement={showPatientSignaturePage6}
                                                setShowAgreement={setShowPatientSignaturePage6}
                                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                                formData={PatientRegistrationFormData}
                                                title={"Patient/Responsible Party Signature"}
                                            />
                                        ) : (
                                            <DisabledTextBox></DisabledTextBox>
                                        )}
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 ga mb-8">
                                    <div className="w-full rounded-lg bg-white">
                                        {/* Signature Label */}
                                        {!PatientRegistrationFormData.isMinor && (
                                            <label className="block text-base font-medium text-black mb-3">
                                                Responsible Party Signature
                                            </label>
                                        )}
                                        {/* Signature Canvas */}
                                        <div className="relative">
                                            <div className="mb-4">
                                                {PatientRegistrationFormData.isMinor ? (

                                                    <Agree
                                                        showAgreement={showPatientSignaturePage6}
                                                        setShowAgreement={setShowPatientSignaturePage6}
                                                        signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                                        formData={PatientRegistrationFormData}
                                                        title={"Responsible Party Signature"}
                                                    />
                                                ) : (
                                                    <DisabledTextBox className="w-full h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black" />


                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col">
                                        <label
                                            htmlFor="responsiblePersonRelationship"
                                            className="block text-base font-medium text-black mb-2"
                                        >
                                            Relationship With Patient
                                        </label>
                                        <input
                                            id="responsiblePersonRelationship"
                                            type="text"
                                            value={
                                                PatientRegistrationFormData.responsiblePersonRelationship
                                            }
                                            onChange={handleInputChange}
                                            disabled={isNext || !PatientRegistrationFormData.isMinor}
                                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>
                )}
                {/* Page 4 */}
                {currentPage === 3 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>


                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: false,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key='dob'
                                    id='dob'
                                    label='DOB'
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData['dob']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                                    required={false}
                                />

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />

                            </div>

                            {/* Medication */}
                            <TextInput
                                id="reason"
                                label="What brings you in to see us?"
                                value={PatientRegistrationFormData.reason}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("reason") && !PatientRegistrationFormData.reason}
                            />


                            {/* Medication */}
                            <TextInput
                                id="medication"
                                label="List of Medication"
                                value={PatientRegistrationFormData.medication}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("medication") && !PatientRegistrationFormData.medication}
                            />
                            {/* Allergies */}
                            <TextInput
                                id="allergies"
                                label="Allergies To Medications"
                                value={PatientRegistrationFormData.allergies}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("allergies") && !PatientRegistrationFormData.allergies}
                            />

                            <div className={`my-4 grid gap-6 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* Left Column - Symptoms */}
                                <SymptomCheckboxGroup
                                    title="Do you presently have any of the following symptoms?"
                                    symptomsData={PatientRegistrationFormData.symptoms}
                                    sectionKey="symptoms"
                                    onChange={handleCheckboxChange}
                                    isDisabledYes={isDisabled}   // your existing flag
                                    isDisabledNo={isNext}         // your existing flag
                                />

                                <SymptomCheckboxGroup
                                    title="Indicate your past or present medical history"
                                    symptomsData={PatientRegistrationFormData.medicalHistory}
                                    sectionKey="medicalHistory"
                                    onChange={handleCheckboxChange}
                                    isDisabledYes={isDisabled}   // your existing flag
                                    isDisabledNo={isNext}         // your existing flag
                                />


                            </div>
                        </div>
                    </div>
                )}
                {/* Page 5 */}
                {currentPage === 4 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: false,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                                <FormInput
                                    key='dob'
                                    id='dob'
                                    label='DOB'
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData['dob']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                                    required={false}
                                />

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />

                            </div>

                            <FamilyDiseases
                                familyDiseases={PatientRegistrationFormData.familyDiseases}
                                handleFamilyHistoryChange={handleFamilyHistoryChange}
                                isNext={isNext}
                            />
                            {/* List Of Surgeries */}

                            <TextInput
                                id="surgeries"
                                label="List of surgeries You Have Had In The Past"
                                value={PatientRegistrationFormData.surgeries}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("surgeries") && !PatientRegistrationFormData.surgeries}
                            />

                            <div>
                                {/* Do you smoke? question */}
                                <div className="flex items-center gap-4 mb-4">
                                    <label className="text-base font-medium text-black">
                                        Do you smoke?
                                    </label>

                                    {/* Yes/No Checkboxes */}
                                    <div className="flex items-center gap-4">
                                        <input
                                            type="checkbox"
                                            id="smoke-yes"
                                            checked={PatientRegistrationFormData.smoker === true}
                                            onChange={() => {
                                                handleCheckChange("smoker", true);
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    smokedInPast: "", // Clear packs per day when smoker is checked
                                                }));
                                            }}
                                            disabled={isNext}
                                            className="form-radio font-medium h-5 w-5 border-gray-700 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="smoke-yes"
                                            className="text-base font-medium text-black"
                                        >
                                            Yes
                                        </label>

                                        <input
                                            type="checkbox"
                                            id="smoke-no"
                                            checked={PatientRegistrationFormData.smoker === false}
                                            onChange={() => {
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    packsPerDay: "", // Assign the value directly
                                                }));
                                                handleCheckChange("smoker", false);
                                            }}
                                            disabled={isNext}
                                            className="form-radio font-medium h-5 w-5 border-gray-700 checked:bg-blue-600"
                                        />
                                        <label htmlFor="smoke-no" className="text-base font-medium text-black">
                                            No
                                        </label>

                                        <label
                                            htmlFor="packs-per-day"
                                            className="text-base font-medium text-black"
                                        >
                                            Packs per day:
                                        </label>
                                        <input
                                            id="packsPerDay"
                                            type="number"
                                            min="0"
                                            value={PatientRegistrationFormData.packsPerDay}
                                            onChange={handleInputChange}
                                            disabled={
                                                isNext ||
                                                PatientRegistrationFormData.smoker === false
                                            }
                                            className="h-8 w-16 px-3 py-2 bg-slate-50 font-medium border-0 border-b-2 border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 mb-4">
                                <label className="text-base font-medium text-black">
                                    Have you smoked in the past?
                                </label>

                                <div className="flex items-center gap-4">
                                    <input
                                        type="radio"
                                        id="smoked-past-yes"
                                        name="smoked-past"
                                        value="yes"
                                        checked={PatientRegistrationFormData.smokedInPast === true}
                                        onChange={() => handleCheckChange("smokedInPast", true)}
                                        disabled={
                                            isNext || PatientRegistrationFormData.smoker === true
                                        }
                                        className="form-radio h-5 w-5 bg-slate-50 font-medium border-0 border-b-2 border-gray-700  checked:bg-blue-600"
                                    />
                                    <label
                                        htmlFor="smoked-past-yes"
                                        className="text-base font-medium text-black"
                                    >
                                        Yes
                                    </label>

                                    <input
                                        type="radio"
                                        id="smoked-past-no"
                                        name="smoked-past"
                                        value="no"
                                        checked={PatientRegistrationFormData.smokedInPast === false}
                                        onChange={() => handleCheckChange("smokedInPast", false)}
                                        disabled={
                                            isNext || PatientRegistrationFormData.smoker === true
                                        }
                                        className="form-radio h-5 w-5 font-medium border-gray-700 checked:bg-blue-600"
                                    />
                                    <label
                                        htmlFor="smoked-past-no"
                                        className="text-base font-medium text-black"
                                    >
                                        No
                                    </label>
                                </div>
                            </div>

                            <div>
                                {/* Do you drink alcohol? question */}
                                <div className="flex items-center gap-4 mb-4">
                                    <label className="text-base font-medium text-black">
                                        Do you drink alcohol?
                                    </label>

                                    {/* Yes/No Radio Buttons */}
                                    <div className="flex items-center gap-4">
                                        <input
                                            type="radio"
                                            id="alcohol-yes"
                                            name="alcohol"
                                            value="yes"
                                            checked={
                                                PatientRegistrationFormData.drinksAlcohol === true
                                            }
                                            onChange={() => handleCheckChange("drinksAlcohol", true)}
                                            disabled={isNext}
                                            className="form-radio h-5 w-5 font-medium border-gray-700 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="alcohol-yes"
                                            className="text-base font-medium text-black"
                                        >
                                            Yes
                                        </label>

                                        <input
                                            type="radio"
                                            id="alcohol-no"
                                            name="alcohol"
                                            value="no"
                                            checked={
                                                PatientRegistrationFormData.drinksAlcohol === false
                                            }
                                            onChange={() => {
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    glassesPerDay: "", // Assign the value directly
                                                }));
                                                handleCheckChange("drinksAlcohol", false);
                                            }}
                                            disabled={isDisabled}
                                            className="form-radio h-5 w-5 font-medium border-gray-700 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="alcohol-no"
                                            className="text-base text-black font-medium"
                                        >
                                            No
                                        </label>

                                        <label
                                            htmlFor="glasses-per-day"
                                            className="text-base font-medium text-black"
                                        >
                                            Number of glasses per day:
                                        </label>
                                        <input
                                            id="glassesPerDay"
                                            type="number"
                                            min="0"
                                            value={PatientRegistrationFormData.glassesPerDay}
                                            onChange={handleInputChange}
                                            disabled={
                                                isNext ||
                                                PatientRegistrationFormData.drinksAlcohol === false
                                            }
                                            className="h-8 w-16 px-3 py-2 font-medium border border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Are you married? question */}
                            <div className="flex items-center gap-4 mb-4">
                                <label className="text-base font-medium text-black">
                                    Are you married?
                                </label>

                                {/* Yes/No Radio Buttons */}
                                <div className="flex items-center gap-4">
                                    <input
                                        type="radio"
                                        id="married-yes"
                                        name="married"
                                        value="yes"
                                        checked={PatientRegistrationFormData.isMarried === true}
                                        onChange={() => handleCheckChange("isMarried", true)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-700 font-medium checked:bg-blue-600"
                                    />
                                    <label
                                        htmlFor="married-yes"
                                        className="text-base text-black font-medium"
                                    >
                                        Yes
                                    </label>

                                    <input
                                        type="radio"
                                        id="married-no"
                                        name="married"
                                        value="no"
                                        checked={PatientRegistrationFormData.isMarried === false}
                                        onChange={() => handleCheckChange("isMarried", false)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-700 checked:bg-blue-600"
                                    />
                                    <label htmlFor="married-no" className="text-base font-medium text-black">
                                        No
                                    </label>
                                </div>
                            </div>

                            {/* Do you drive? question */}
                            <div className="flex items-center gap-4 mb-4">
                                <label className="text-base font-medium text-black">
                                    Do you drive?
                                </label>

                                {/* Yes/No Radio Buttons */}
                                <div className="flex items-center gap-4">
                                    <input
                                        type="radio"
                                        id="drive-yes"
                                        name="drive"
                                        value="yes"
                                        checked={PatientRegistrationFormData.doYouDrive === true}
                                        onChange={() => handleCheckChange("doYouDrive", true)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-700 checked:bg-blue-600"
                                    />
                                    <label htmlFor="drive-yes" className="text-base font-medium text-black">
                                        Yes
                                    </label>

                                    <input
                                        type="radio"
                                        id="drive-no"
                                        name="drive"
                                        value="no"
                                        checked={PatientRegistrationFormData.doYouDrive === false}
                                        onChange={() => handleCheckChange("doYouDrive", false)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-700 checked:bg-blue-600"
                                    />
                                    <label htmlFor="drive-no" className="text-base font-medium text-black">
                                        No
                                    </label>
                                </div>
                            </div>

                            {/* Other Important Information */}
                            <TextInput
                                id="other_important_information"
                                label="Other Important Information"
                                value={PatientRegistrationFormData.other_important_information}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                invalid={invalidFields.includes("other_important_information") && !PatientRegistrationFormData.other_important_information}
                            />

                            <Agree
                                showAgreement={showPatientSignaturePage4}
                                setShowAgreement={setShowPatientSignaturePage4}
                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                formData={PatientRegistrationFormData}
                                title={"Patient/Responsible Party Signature"}
                            />
                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* date*/}

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {/* Page 6 */}
                {currentPage === 5 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <PrivacyConsent />
                            {/* Signature Section */}
                            <div className="mb-8">
                                <p className="text-base font-medium text-black mb-3">
                                    {PatientRegistrationFormData.firstName}{" "}
                                    {PatientRegistrationFormData.lastName} - {formattedDate}
                                </p>
                            </div>


                            <Agree
                                showAgreement={showPatientSignaturePage5}
                                setShowAgreement={setShowPatientSignaturePage5}
                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                formData={PatientRegistrationFormData}
                                title={"Patient/Responsible Party Signature"}
                            />


                            {/* Permissions Section */}
                            <FamilyMemberConsent
                                familyMembers={PatientRegistrationFormData.familyMembers}
                                handleFamilyChange={handleFamilyContentChange}
                                handleAddMember={handleAddMember}
                                handleRemoveFamilyMember={handleRemoveFamilyMember}
                                DOBPickerComponent={DOBPickerInput} // pass your component
                                fileUpload={isNext}
                                nextLoader={nextLoader}
                                FaTrash={FaTrash}
                                FaPlus={FaPlus}
                                title={'Retina Specialty Institute'}
                            />
                        </div>
                    </div>
                )}
                {/* Page 7 */}
                {currentPage === 6 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                                bg-white w-full mx-auto
                                ${!isNext
                            ? "max-w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-4 sm:px-6"
                            : "w-[1200px]"
                        }
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <ImageConsent />
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: false,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key='dob'
                                    id='dob'
                                    label='DOB'
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData['dob']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                                    required={false}
                                />

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />

                            </div>

                            {isNext ? null : (
                                <div className="flex items-center gap-4 mb-4 pt-4">

                                    <MedicalPortalAccess
                                        id="imageConsent"
                                        label="If you do not wish to grant permission for the use of your images as outlined above,
please check the box below. Do you consent to release any images that have been or will be taken of my eyes for the purposes described above?"
                                        portalValue={PatientRegistrationFormData.imageConsent}
                                        onChange={handleInputChange}
                                        isDisabled={isDisabled}
                                    />
                                </div>
                            )}


                            {PatientRegistrationFormData.imageConsent === "true" ? (
                                <div className="w-full bg-white">
                                    {/* Signatures Section */}
                                    {/* Patient Signature */}
                                    <div className="w-full rounded-lg bg-white">
                                        {/* Signature Canvas */}
                                        <div className="relative">
                                            {PatientRegistrationFormData.isMinor ? (
                                                <div className="w-1/2 rounded-lg bg-white">
                                                    {/* Signature Label */}
                                                    <label className="block text-base font-medium text-black mb-3">
                                                        Responsible Party Signature
                                                    </label>
                                                    <img
                                                        src={signatures["responsiblePersonSignature"]}
                                                        alt="Responsible Party Signature"
                                                        loading="eager"
                                                        style={{
                                                            width: '300px',
                                                            height: '100px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="w-1/2 rounded-lg bg-white">
                                                    {/* Signature Label */}
                                                    <label className="block text-base font-medium text-black mb-3">
                                                        Patient Signature
                                                    </label>
                                                    <img
                                                        src={signatures["patientSignature"]}
                                                        alt="Patient Signature"
                                                        loading="eager"
                                                        style={{
                                                            width: '300px',
                                                            height: '100px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <Paragraph>I understand that my decision to decline consent will not affect my care or treatment
                                at Retina Specialty Institute.</Paragraph>
                            <div></div>
                        </div>
                    </div>
                )}
                {/* Page 7 */}
                {currentPage === 7 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                            bg-white w-full
                            ${!isNext ? "max-w-full sm:max-w-2xl md:max-w-4xl lg:max-w-6xl" : "w-full md:max-w-[1200px] md:mx-auto"}
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <PCMConsent />
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: false,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key='dob'
                                    id='dob'
                                    label='DOB'
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData['dob']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                                    required={false}
                                />

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />

                            </div>
                            <p className="mb-2 font-medium">
                                Acknowledgment & Consent
                            </p>
                            <p className="mb-2 font-medium">
                                I have read and understand this information and agree to participate in Principal Care
                                Management services for my ophthalmic/retinal condition. I certify that all my questions and
                                concerns regarding the PCM program, its attendant risks, benefits, and alternatives have been
                                explained to my satisfaction, and I accept them and consent to participation in the PCM program.
                            </p>

                            {isNext ? null : (
                                <div className="flex items-center gap-4 mb-4 pt-4">

                                    <MedicalPortalAccess
                                        id="pcm_consent"
                                        label=""
                                        portalValue={PatientRegistrationFormData.pcm_consent}
                                        onChange={handleInputChange}
                                        isDisabled={isDisabled}
                                    />
                                </div>
                            )}


                            {PatientRegistrationFormData.pcm_consent === "true" ? (
                                <div className="w-full bg-white">
                                    {/* Signatures Section */}
                                    {/* Patient Signature */}
                                    <div className="w-full rounded-lg bg-white">
                                        {/* Signature Canvas */}
                                        <div className="relative">
                                            {PatientRegistrationFormData.isMinor ? (
                                                <div className="rounded-lg bg-white">
                                                    {/* Signature Label */}
                                                    <label className="block text-base font-medium text-black mb-3">
                                                        Responsible Party Signature
                                                    </label>
                                                    <div className={`grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                                        <img
                                                            src={signatures["responsiblePersonSignature"]}
                                                            alt="Responsible Party Signature"
                                                            loading="eager"
                                                            style={{
                                                                width: '300px',
                                                                height: '100px',
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                                objectFit: 'contain',
                                                                display: 'block',
                                                            }}
                                                        />

                                                        <FormInput
                                                            key='responsiblePersonRelationship'
                                                            id='responsiblePersonRelationship'
                                                            label='Relationship to Patient'
                                                            type="text"
                                                            disabled={true}
                                                            value={PatientRegistrationFormData.responsiblePersonRelationship}
                                                            onChange={handleInputChange}
                                                            invalid={false}
                                                            required={false}
                                                        />

                                                    </div>

                                                </div>
                                            ) : (
                                                <div className="w-1/2 rounded-lg bg-white">
                                                    {/* Signature Label */}
                                                    <label className="block text-base font-medium text-black mb-3">
                                                        Patient Signature
                                                    </label>
                                                    <img
                                                        src={signatures["patientSignature"]}
                                                        alt="Patient Signature"
                                                        loading="eager"
                                                        style={{
                                                            width: '300px',
                                                            height: '100px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                            objectFit: 'contain',
                                                            display: 'block',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            <div></div>
                        </div>
                    </div>
                )}
                {/* Page 8 */}
                {currentPage === 8 && (
                    <div ref={pageRefs.current[currentPage]} className={`
                            bg-white w-full
                            ${!isNext ? "max-w-full sm:max-w-2xl md:max-w-4xl lg:max-w-6xl" : "w-full md:max-w-[1200px] md:mx-auto"}
                        `}
                        style={{ transformOrigin: "top left" }}>
                        <FormHeader pageTitle={subPageTitle} />
                        <div className={`px-4 sm:px-6 md:px-20 py-2`}>
                            <FinancialPolicy />
                            <div className="mt-4 w-full bg-white">
                                {/* Patient Signature */}
                                <div className="w-full rounded-lg bg-white">
                                    {/* Signature Canvas */}

                                    <Agree
                                        showAgreement={showPatientSignaturePage6}
                                        setShowAgreement={setShowPatientSignaturePage6}
                                        signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                        formData={PatientRegistrationFormData}
                                        title={"Patient/Responsible Party Signature"}
                                    />

                                </div>
                            </div>


                            <div className={`my-4 grid gap-3 grid-cols-2`}>
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: false,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 grid-cols-2`}>
                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />

                            </div>
                        </div>
                    </div>
                )}

            </form>
            <div className="mt-10">
                <ButtonGroup
                    isDisabled={isDisabled}
                    currentPage={currentPage}
                    handleEdit={handleEdit}
                    handleNext={handleNext}
                    handlePatientRegistration={handlePatientRegistration}
                />
            </div>
        </>
    );
};

export default RSIRegistration;
